import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { useAppDispatch } from "hooks/redux";
import { showError } from "redux/actions/ui";
import {
  buildReportDefaultParams,
  isReportDefaultParamsFailure,
} from "pages/secure/shared/reports/buildReportDefaultParams";
import { buildReportRunUrl } from "pages/secure/shared/reports/reportAutoRun/buildReportRunUrl";
import { IMergedReportEntry, TReportAdminScope } from "pages/secure/shared/reports/reportCatalog.types";

interface IUseNavigateToReportRunOptions {
  scope: TReportAdminScope;
  dedicatedRouteCodes: ReadonlySet<string>;
}

export function useNavigateToReportRun(options: IUseNavigateToReportRunOptions) {
  const { scope, dedicatedRouteCodes } = options;
  const history = useHistory();
  const dispatch = useAppDispatch();

  return useCallback(
    async (report: IMergedReportEntry) => {
      const paramsResult = await buildReportDefaultParams({
        scope,
        reportId: report.id,
        code: report.code,
        isDedicatedRoute: dedicatedRouteCodes.has(report.code),
      });

      if (isReportDefaultParamsFailure(paramsResult)) {
        dispatch(showError(paramsResult.errorMessage));
        return;
      }

      history.push(buildReportRunUrl(report.url), {
        reportAutoRunParams: paramsResult.params,
      });
    },
    [dedicatedRouteCodes, dispatch, history, scope],
  );
}
